import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class DisplayNameValidation extends CustomCommonValidator implements ValidatorConstraintInterface {
	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		let properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
		let result: boolean = true;
		const validator = this.getValidator();
		this.message = '';
		if (properties.find(p => p == 'displayName') != null) {
			let displayName: any = dynamicProperties['displayName'] as any;
			let languages = Object.getOwnPropertyNames(displayName);
			let res = [];
			for (let lang of languages) {
				if (!validator.isNotEmpty(displayName[lang])) {
					res.push(false);
				}
			}
			if (res.some(x => x == false)) {
				this.message = this.message.concat('Title is required');
				result = false;
			}
		}
		return result;
	}

	defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/displayNameValidator.ts